import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-calls-contrat-sav',
  templateUrl: './search-calls-contrat-sav.component.html',
  styleUrls: ['./search-calls-contrat-sav.component.scss']
})
export class SearchCallsContratSavComponent implements OnInit {

  constructor() { }


  typesContrat : string[] = [
    'Garantie', 'Assistance téléphonique 5/7', 'LAURENT - Contrat de maintenance 5/7', 'Assistance téléphonique 7/7',
    'Bloqué', 'Extension de garantie 1 an', 'Contrat de maintenance', 'Contrat de maintenance + pièces', 'Contrat de maintenance ARMEES',
    'CONTRAT PIECES EXPORT'
  ];

  ngOnInit(): void {
  }

}
